<template>
  <div class="LoginForm d-flex flex-column h-100">
    <h1 class="text-center mb-4 pb-2">Account herstel</h1>
    <div style="min-height: 60px">
      <Feedback :feedback="feedback" />
    </div>
    <Form 
      class="flex-grow-1"
      @submit="handleSubmit">
      
      <FormField 
        v-model="fields.password.value"
        v-bind="fields.password"
        class="mt-2" />
      
      <button 
        type="submit"
        :disabled='isDisabled'
        class="btn btn-success btn-lg btn-block rounded-pill font-weight-bold border-0 mt-3 p-3">
        Nieuw wachtwoord instellen
      </button>
    </Form>

    <div class="d-flex justify-content-center mt-5">
      <router-link 
        class="text-muted"
        :to="{ name: 'login' }">
        Annuleren
      </router-link>
    </div>
  </div>
</template>

<script>
import { update, recoverAccount, getUser } from 'service/auth'
import { mapMutations } from 'vuex'

import { required } from 'vuelidate/lib/validators';

import Feedback from 'atom/Feedback'
import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import fields from 'mixin/fields'
import timeout from 'mixin/timeout'

export default {
  name: 'RecoverForm',
  components: {
    Feedback,
    Form,
    FormField
  },
  mixins: [ fields, timeout ],
  data() {
    return {
      feedback: {},
      isDisabled: false,
      token: '',
      fields: {
        password: {
          label: "Wachtwoord",
          autocomplete: "new-password",
          type: "password",
          value: '',
          validationRules: {
            required
          },
          disabled: false
        }
      }
    }
  },
  created() {
    this.feedback = {
      variant: 'info', 
      message: 'Bezig met valideren van herstel code'
    }
    this.disableAllFields()
    this.isDisabled = true
    
    if (this.$route.hash) {
      // Get the token, after #recovery_token=
      this.token = this.$route.hash.split("=").pop()
      
      // Clear hash from route
      this.$router.push({ name: this.$route.name })
    }
    
    recoverAccount({ token: this.token })
      .then(() => {
        this.enableAllFields()
        this.isDisabled = false
        this.feedback = {
          variant: 'info', 
          message: 'Voer hier uw nieuwe wachtwoord in'
        }
      })
      .catch(() => {
        this.feedback = {
          variant: 'danger', 
          message: 'Uw herstel code is ongeldig. Vraag een nieuwe herstel e-mail aan.'
        }
      })
  },
  methods: {
    ...mapMutations('user', [
      'setUser'
    ]),
    handleSubmit(e) {
      e.preventDefault();
      
      this.disableAllFields()
      this.isDisabled = true
      this.feedback = {
        variant: 'info', 
        message: 'Bezig met wijzigen van wachtwoord...'
      }

      update({
        password: this.fieldValue('password')
      })
        .then(() => {
          this.feedback = {
            variant: 'success', 
            message: 'Uw wachtwoord is gewijzigd. U wordt automatisch ingelogd.'
          }
          this.setUser({ authenticatedUser: getUser() })
          this.setTimeout(() => {
            this.$router.push({ name: 'home' })
          }, 2000)
        })
        .catch((err) => {
          this.enableAllFields()
          
          this.isDisabled = false
          if (err && err.status === 401) {
            this.feedback = {
              variant: 'danger', 
              message: 'Uw nieuwe wachtwoord is niet opgeslagen'
            }
          } else {
            this.feedback = {
              variant: 'danger', 
              message: 'Onbekende fout. Probeer het later nog eens.'
            }
          }
        })
    },
  }
}
</script>
